import request from '@/config/axios'

// 获取系统设置
export const GetSystemSetting = (params) => {
  return request.get({
    url: 'system/general/setting',
    params,
    baseUrl:'m2i'
  })
}

export const SetSystemSetting = (data) => {
   return request.post({
     url: 'system/general/setting',
     data,
    baseUrl:'m2i'
   })
}

export const GetLang = (params) => {
  return request.get({
    url: 'i18n-data',
    baseUrl:'m2i',
    params: params,
    timeout: 5000
  })
}

export const RegisterLang = (data) => {
  return request.post({
    url: '/i18n-data',
    baseUrl:'m2i',
    data: data,
    timeout: 5000
  })
}